export const SEAT_PRICE = 20;
export const MAX_PRO_SEATS = 100;
export const TRIAL_DAYS = 30;

export type PlanType = 'trial' | 'pro' | 'enterprise';

export interface Subscription {
  id: string;
  company_id: string;
  plan_type: PlanType;
  trial_ends_at: string | null;
  paid_seats: number;
  seat_price_per_month: number;
  status: string;
  created_at: string;
  updated_at: string;
}

export const isPaidRole = (role: string): boolean => {
  return ['creator', 'reviewer', 'approver'].includes(role);
};

export const calculateTrialDaysRemaining = (trialEndsAt: string | null): number => {
  if (!trialEndsAt) return 0;
  
  const now = new Date();
  const trialEnd = new Date(trialEndsAt);
  const diffTime = trialEnd.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return Math.max(0, diffDays);
};

export const calculateMonthlyCost = (paidSeats: number): number => {
  return paidSeats * SEAT_PRICE;
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

export const getPlanFeatures = (planType: PlanType): string[] => {
  switch (planType) {
    case 'trial':
      return [
        'Full access to all features',
        '30-day trial period',
        'All policy management tools',
        'Team collaboration',
      ];
    case 'pro':
      return [
        'Everything in Trial',
        '$20 per user/month',
        'Users with Creator, Reviewer, or Approver roles',
        'Unlimited Viewer users (free)',
        'Up to 100 team members',
        'Priority support',
      ];
    case 'enterprise':
      return [
        'Everything in Pro',
        'Unlimited team members',
        'On-premise deployment',
        'Dedicated account manager',
        'Custom integrations',
        '24/7 priority support',
        'SLA guarantee',
      ];
    default:
      return [];
  }
};
